import { IdBuyBody, SubscriptionApi, SubscriptionPackage } from '@bpm-web-app/supreme-api-sdk';
import { supremeConfig } from '../config';

export class Product {
    static client = new SubscriptionApi(supremeConfig);

    static getProducts = (platform: SubscriptionPackage.PlatformEnum) => Product.client.getProductsForPlatform(platform as unknown as string);

    static getProduct = (sku: string) => Product.client.getProduct(sku);

    static buyProuct = (productid: number, body: IdBuyBody) => Product.client.buyProduct(productid, body);
}
